/* eslint-disable react/react-in-jsx-scope */
import { Skeleton } from "@/components/ui/skeleton";
import { ChevronRight } from "lucide-react";

const HeaderDescriptifSkeleton = () => {
  return (
    <>
      <div className="flex gap-2 items-center">
        <Skeleton className="w-28 h-5" />{" "}
        <ChevronRight className="text-gray-500" size={18} />
        <Skeleton className="w-28 h-5" />
      </div>
      <div>
        <Skeleton className="w-[600px] h-5 rounded-[20px] mt-5" />
        <div className="flex flex-row gap-4">
          <Skeleton className="w-[300px] h-5 rounded-[20px] mt-3" />
          <Skeleton className="w-[70px] h-5 rounded-[20px] mt-3" />
        </div>
      </div>
      <div className="flex flex-col gap-3 mt-5">
        <Skeleton className="w-[500px] h-3 rounded-[20px] mt-3" />
        <Skeleton className="w-[300px] h-3 rounded-[20px] mt-3" />
        <Skeleton className="w-[200px] h-3 rounded-[20px] mt-3" />
        <Skeleton className="w-[300px] h-3 rounded-[20px] mt-3" />
        <Skeleton className="w-[500px] h-3 rounded-[20px] mt-3" />
        <Skeleton className="w-[200px] h-3 rounded-[20px] mt-3" />
        <Skeleton className="w-[500px] h-3 rounded-[20px] mt-3" />
      </div>
    </>
  );
};

export default HeaderDescriptifSkeleton;
